import { ITriadDiscountInfo } from "@app/shared-widgets/shared-widgets.models";
import { createEntityAdapter, EntityAdapter } from "@ngrx/entity";

export const triadDiscountAdapter: EntityAdapter<ITriadDiscountInfo> = createEntityAdapter<ITriadDiscountInfo>({
	selectId: discount => discount.accountId
});